import CustomReportTemplateIcon from '../../components/SVGComponents/CustomReportTemplateIcon';
import { ControlAndSettingsIcon } from '../../components/SVGComponents/ControlAndSettingsIcon';
import { YourReportsIcon } from '../../components/SVGComponents/YourReportsIcon';
import { SELECTED_TAB_KEY } from "../../constants/Constants";
import CustomToolTipHost from '../../components/CustomToolTipHost/CustomToolTipHost';
import { Icon } from '@fluentui/react';

export const breadCrumbItems = [
    {
      text: 'PACS Queue List',
      key: 'masters',
    },
  ];

export const tabDetails = (selectedValue) => {
    return [
      {
        id: SELECTED_TAB_KEY.PACSQUEUE + '1',
        title: "Pending",
        contentClass: 'tabContent',
        icon: (
          <CustomReportTemplateIcon
            active={selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '1'}
          />
        ),
      },
      {
        id: SELECTED_TAB_KEY.PACSQUEUE + '2',
        title: "Completed",
        contentClass: 'tabContent',
        icon: (
          <ControlAndSettingsIcon
            active={selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '2'}
          />
        ),
      },
      {
        id: SELECTED_TAB_KEY.PACSQUEUE + '3',
        title: "Cancelled",
        contentClass: 'tabContent',
        icon: (
          <YourReportsIcon
            active={selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '3'}
          />
        ),
      },
    ];
  };

  export const pacsQueueInitialState = {
    destination: null,
    patientId: null,
    patientName: null,
    jobId: null
  };

  export const searchStyle = {
    root: {
      background: 'transparent',
      border: '1px solid rgba(200, 198, 196, 0.3)',
      borderRadius: '5px',
    },
  };

  export const iconButtonStyles = {
    icon: { color: "#0078d4", border: "none", outline: "none" },
    root: {
      backgroundColor: 'transparent',
      // selectors: {
      //   ':hover .ms-Button-icon': {
      //     color: '#0078d4'
      //   },
      // },
      width: "20px",
      height: "20px",
      margin: "2px",
    },
    rootHovered: { backgroundColor: 'transparent' },
    rootPressed: { backgroundColor: 'transparent' }
  };

  export const cancelIconButtonStyles = {
    icon: { color: "red", border: "none", outline: "none" },
    root: {
      backgroundColor: 'transparent',
      width: "20px",
      height: "20px",
      margin: "2px",
    },
    rootHovered: { backgroundColor: 'transparent' },
    rootPressed: { backgroundColor: 'transparent' }
  };

  export const getStatusIcon = (status) => {
    let color, tooltipContent;
    switch (status) {
      case 3:
        color = 'green';
        tooltipContent = "Completed";
        break;
      case 4:
        return (
          <CustomToolTipHost content="Completed With Errors">
            <div>
              <Icon iconName="CircleShapeSolid" style={{ color: 'green', paddingRight: '5px' }} />
              <Icon iconName="WarningSolid" style={{ color: '#FFC000' }} />
            </div>
          </CustomToolTipHost>
        );
      case 0:
        color = 'gray';
        tooltipContent = "Scheduled";
        break;
      case 1:
        color = 'orange';
        tooltipContent = "Pending";
        break;
      case 2:
        color = 'red';
        tooltipContent = "Cancelled";
        break;
      default:
        color = 'black'; // Default color if status is undefined
        tooltipContent = "Unknown status";
    }
    return (
      <CustomToolTipHost content={tooltipContent}>
        <Icon iconName="CircleShapeSolid" style={{ color }} />
      </CustomToolTipHost>
    );
  };